import 'live/services/authorization'

const isAdmin = (): boolean => Live.authorization.Permission.ADMIN || Live.authorization.Permission.SUPER_USER

export default {
    canUseAnnotationsTemplates(): boolean {
        return isAdmin() || Live.authorization.Permission.USE_ADVANCED_ANNOTATIONS
    }
}

export const getPerspectives = async (): Promise<{ data: [{ name: string; id: string }]}> => {
    return fetch('/rest/perspective', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(response => {
        let jsonData

        try {
            jsonData = response.json()
        } catch {
            jsonData = null
        }

        if (!response.ok) {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }

        return jsonData
    })
}
